'use client'

import { useScreenReaderAnnouncements } from '@/hooks/useAccessibility'

/**
 * Screen Reader Announcements component
 * Provides ARIA live regions for dynamic content updates
 */
export function ScreenReaderAnnouncements() {
  const { announcement, politeness } = useScreenReaderAnnouncements()

  return (
    <>
      {/* Polite announcements for non-critical updates */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        role="status"
        id="polite-announcements"
      >
        {politeness === 'polite' && announcement}
      </div>

      {/* Assertive announcements for critical updates */}
      <div
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
        role="alert"
        id="assertive-announcements"
      >
        {politeness === 'assertive' && announcement}
      </div>

      {/* Status updates */}
      <div role="status" aria-live="polite" className="sr-only" id="status-updates" />
    </>
  )
}

export default ScreenReaderAnnouncements
